import { atom } from "recoil";

export const gomakeUserState = atom({
  key: "gomakeUserState",
  default: {},
});